import { render, staticRenderFns } from "./vuex-select.vue?vue&type=template&id=15e0f4c3&scoped=true"
import script from "./vuex-select.vue?vue&type=script&lang=js"
export * from "./vuex-select.vue?vue&type=script&lang=js"
import style0 from "./vuex-select.vue?vue&type=style&index=0&id=15e0f4c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e0f4c3",
  null
  
)

export default component.exports